<template>
  <div class="extension__form">
    <standard-form :fields="fields" :object="object"></standard-form>
  </div>
</template>

<script>
import StandardForm from '@/components/StandardForm';

export default {
  props: ['object', 'fields'],
  components: {
    StandardForm,
  },
};
</script>
